import React__default from 'react';
import classnames from 'classnames';
import { Price } from '@grandvisionhq/common';

const Discount = ({ absoluteValue , relativeValue , currency , labels , className  })=>{
    const hasAbsoluteValue = absoluteValue > 0;
    const hasRelativeValue = (relativeValue !== null && relativeValue !== void 0 ? relativeValue : 0) > 0;
    if (!hasAbsoluteValue && !hasRelativeValue) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('line-item-discount__section', className)
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "line-item-discount__section-text"
    }, labels.discount, "\xa0"), hasRelativeValue ? /*#__PURE__*/ React__default.createElement("span", {
        className: "line-item-discount__section-value"
    }, relativeValue, "%") : hasAbsoluteValue && /*#__PURE__*/ React__default.createElement(Price, {
        value: absoluteValue,
        currency: currency,
        className: "line-item-discount__section-price",
        type: "discount"
    }));
};

export { Discount };
//# sourceMappingURL=Discount.js.map
